import { useTheme } from '@automata/mui-theme';
import { FieldError } from '@automata/ui';
import { Box, Button, Stack, Typography } from '@mui/material';
import { FC } from 'react';

import { FieldValue } from './types';
import { Option } from '../../types';
import { getFieldType } from '../../utils';
import { DynamicFormField } from '../DynamicFormField';

interface FormFieldRowProps {
  changed: boolean;
  configMeta: any;
  error?: string | null;
  instrumentName: string;
  fieldKey: string;
  value: FieldValue;
  onChange: (instrumentName: string, key: string, val: FieldValue) => void;
  onReset: (instrumentName: string, key: string) => void;
}

export const FormFieldRow: FC<FormFieldRowProps> = ({
  changed,
  configMeta,
  error,
  fieldKey,
  instrumentName,
  value,
  onChange,
  onReset,
}) => {
  const theme = useTheme();

  return (
    <Box mb={1}>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
        spacing={1}
      >
        <Box sx={{ flexGrow: 1, maxWidth: '236px' }}>
          <DynamicFormField
            invalid={!!error}
            label={fieldKey}
            min={configMeta?.min_value}
            max={configMeta?.max_value}
            options={
              Array.isArray(value) && typeof value[0] === 'object'
                ? (value as unknown as Option[])
                : undefined
            }
            required={configMeta?.is_required}
            type={getFieldType(configMeta?.type)}
            value={value}
            onChange={(val) => onChange(instrumentName, fieldKey, val)}
          />
        </Box>
        {changed && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: '3px',
              height: '40px',
            }}
          >
            <Typography
              color="error"
              fontSize={14}
              sx={theme.typography.overline}
            >
              ●
            </Typography>
            <Button
              variant="text"
              size="small"
              onClick={() => onReset(instrumentName, fieldKey)}
              sx={{
                ...theme.typography.overline,
                paddingBottom: 0,
                marginLeft: 1,
              }}
            >
              Reset
            </Button>
          </Box>
        )}
      </Stack>
      <FieldError error={error} />
    </Box>
  );
};
